
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class UpdateSubscriptionInitialOrderDataRequestModel extends Model<UpdateSubscriptionInitialOrderDataRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'productPlanId', type: 'guid', languageString: 'updateSubscriptionInitialOrderDataRequest.property.productPlanId' },
		{ name: 'customerTenantId', type: 'number', languageString: 'updateSubscriptionInitialOrderDataRequest.property.customerTenantId' },
		{ name: 'billingCycleType', type: 'number', languageString: 'updateSubscriptionInitialOrderDataRequest.property.billingCycleType' },
		{ name: 'partNumber', type: 'string', languageString: 'updateSubscriptionInitialOrderDataRequest.property.partNumber' },
		{ name: 'termDuration', type: 'string', languageString: 'updateSubscriptionInitialOrderDataRequest.property.termDuration' }
	];
	[key: string]: any;
	
	public productPlanId?: string;
	public customerTenantId: number;
	public billingCycleType: number;
	public partNumber: string;
	public termDuration: string;
    
	constructor(){
		super();
		this.productPlanId = undefined;
		this.customerTenantId = 0;
		this.billingCycleType = 0;
		this.partNumber = '';
		this.termDuration = '';
		
	}
	getProperties(){
		return UpdateSubscriptionInitialOrderDataRequestModel.classProperties;
	}
}

